import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import CssClass from "../../../Styles/common.module.css";
import { useState } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import { useRef } from "react";
import { useEffect } from "react";

const CloseTicket = (props) => {
    const [cookies] = useCookies([]);
    const [userId] = useState(cookies.USER_ID);

    const [editData, setEditData] = useState([]);
    const [inputError, setInputError] = useState([]);

    const targetMandaysRef = useRef();
    const requiredMandaysRef = useRef();

    useEffect(() => {
      if (props.viewData !== undefined) {
        setEditData({
          TICKET_MST_ID: props.viewData.TICKET_MST_ID,
          TICKET_NUM: props.viewData.TICKET_NUM,
          ORG_ID: props.viewData.ORG_ID,
          SYSTEM_MST_ID: props.viewData.SYSTEM_MST_ID,
          SYSTEM_MST_NAME: props.viewData.SYSTEM_MST_NAME,
          ACKNOWLEDGED_DATETIME: props.viewData.ACKNOWLEDGED_DATETIME,
          TARGET_MANDAYS: props.viewData.TARGET_MANDAYS,
          TOTAL_COMPLETE_TIME: props.viewData.TOTAL_COMPLETE_TIME,
          STANDBY_TARGET_MANDAYS: props.viewData.STANDBY_TARGET_MANDAYS,
          UPDATE_ID: userId,
          UPDATE_DATETIME: props.viewData.UPDATE_DATETIME,
        })
      }
    }, [props.viewData, userId])

    const SendEmail = (_data) => {
      let functionName = "onSaveConfirmHandler";
  
      try {
          props.onLoading(true, "Sending email, please wait...");
          const data = {
              // TICKET_MST_ID: ticketMstId,
            TICKET_MST_ID: _data.TICKET_MST_ID,
            TICKET_NUM: _data.TICKET_NUM,  
            ORG_ID: _data.ORG_ID,  
            ORG_NAME: _data.ORG_NAME,
            SYSTEM_MST_ID: _data.SYSTEM_MST_ID,
            SYSTEM_MST_NAME: _data.SYSTEM_MST_NAME,
            UPDATE_ID: userId,
          };
          http
              .post("api/Ticket/SendCloseEmail", data, { timeout: common.DEFAULT_TIMEOUT })
              .then((response) => {
                props.onLoading(true, "Sending email...");
              })
              .catch((err) => {    
                common.c_LogWebError(props.page, functionName, err);
              })
              .finally(() => {
                props.onLoading(false, "Loading...");
              })
      } catch (err) {
          props.onLoading(false, "Loading...");
          toast.error("Failed to send email");
          common.c_LogWebError(props.page, functionName, err);
      }
    };

    const closeBtnOnClick = () => {   
      if (Object.values(inputError).filter(v => v !== "").length === 0) {
        CloseTicket(editData);
      }       
    };

    function CloseTicket(_data) {
        let functionName = "";

        try {
          
          functionName = CloseTicket.name;

          props.onLoading(true, "Closing ticket, please wait...");

          const data = {
              TICKET_MST_ID: _data.TICKET_MST_ID,
              TICKET_NUM: _data.TICKET_NUM,
              // TICKET_STATUS_TYPE_ID: _data.TICKET_STATUS_TYPE_ID,
              // TICKET_STATUS_TYPE_NAME: _data.TICKET_STATUS_TYPE_NAME,
              // ACKNOWLEDGED_BY: _data.ACKNOWLEDGED_BY,
              ACKNOWLEDGED_DATETIME: _data.ACKNOWLEDGED_DATETIME,
              TARGET_MANDAYS: _data.TARGET_MANDAYS,
              TOTAL_COMPLETE_TIME: _data.TOTAL_COMPLETE_TIME,
              TICKET_STANDBY_ID: _data.TICKET_STANDBY_ID,
              STANDBY_TARGET_MANDAYS: _data.STANDBY_TARGET_MANDAYS,
              UPDATE_ID: userId,
              UPDATE_DATETIME: _data.UPDATE_DATETIME,
          };

          http
            .post("api/ticket/CloseTicket", data, { timeout: 10000 })
            .then((response) => {
              if (response.data.ACK_STATUS === false) {        
                if (response.data.TICKET_STATUS_TYPE_NAME === "CLOSED") {
                  toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + '.');   
                } else if (response.data.TICKET_STATUS_TYPE_NAME === "CANCEL") {
                  toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + 'led.');   
                }                 
                props.onReload();
                hideModal();
              } else {
                toast.success("Ticket is successfully closed.");
                SendEmail(_data);
                props.onReload();
                hideModal();
              }
            })
            .catch((err) => {
              toast.error("Failed to close ticket. Please try again.");
              common.c_LogWebError(props.page, functionName, err);
            })
            .finally(() => {
                props.onLoading(false, "Loading...");
            });
        } catch (err) {
            props.onLoading(false, "Loading...");
            toast.error("Failed to close ticket. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
        }
    }

    const hideModal = () => {
        props.onHide();
        setEditData({
          TARGET_MANDAYS: props.viewData.TARGET_MANDAYS,
          TOTAL_COMPLETE_TIME: props.viewData.TOTAL_COMPLETE_TIME,
        });
      };

    const inputRequiredHandler = (event) => {
      let functionName = "";
  
      try {
        functionName = inputRequiredHandler.name;
        const name = event.target.name;
        functionName = inputRequiredHandler.name + "_" + name;
        const id = event.target.id;
        const val = event.target.value;
        if (val.length === 0 || val.trim().length === 0) {
          setInputError((prevState) => ({
            ...prevState,
            [id]: name + " could not be empty.",
          }));
        } else {
          setInputError((prevState) => ({
            ...prevState,
            [id]: "",
          }));
        }
        setEditData((prevState) => ({
          ...prevState,
          [id]: val,
        }));
      } catch (err) {
        common.c_LogWebError(props.page, functionName, err);
      }
    };

    const message = (
      <>
        Confirm to close ticket?
        <br />
        <table width={"70%"} style={{margin: "1rem 3rem"}} centered="true">
          <tbody>
            <tr>
              <td style={{textAlign: "left"}}>Ticket Num </td>
              <td width={"5%"}>:</td>
              <td className={CssClass.inputValueLabel}>{props.viewData !== null && props.viewData.TICKET_NUM}</td>
            </tr>
            <tr>
              <td style={{textAlign: "left"}}>Target Mandays </td>
              <td width={"5%"}>:</td>
              <td className={CssClass.inputValueLabel}>{props.viewData !== null && props.viewData.TARGET_MANDAYS}</td>
              {/* <td>
                <Comp.Input 
                  ref={targetMandaysRef}
                  id="TARGET_MANDAYS"
                  type="text"
                  // className={CssClass.inlineInput}
                  value={editData.TARGET_MANDAYS}
                  onChange={inputRequiredHandler}
                />
              </td> */}
            </tr>
            <tr>
              <td style={{textAlign: "left"}}>Required Mandays (dd:hh:mm)</td>
              <td width={"5%"}>:</td>
              <td className={CssClass.inputValueLabel}>{props.viewData !== null && props.viewData.TOTAL_COMPLETE_TIME}</td>
              {/* <td>
                <Comp.Input 
                  ref={requiredMandaysRef}
                  id="TOTAL_COMPLETE_TIME"
                  type="text"
                  // className={CssClass.inlineInput}
                  value={editData.TOTAL_COMPLETE_TIME}
                  onChange={inputRequiredHandler}
                />
              </td> */}
            </tr>
          </tbody>
        </table>
        {/* <div
            style={{
              display: "flex",
              margin: "1rem 5rem",
              textAlign: "left"
            }}
        >
          <label className={CssClass.inputLabel}>Ticket Num </label> 
          <label className={CssClass.inputValueLabel}>{props.viewData !== null && props.viewData.TICKET_NUM}</label>
        </div>
        <div
            style={{
              display: "flex",
              margin: "1rem 5rem",
              textAlign: "left"
            }}
        >
          <label className={CssClass.inputLabel}>Target Mandays </label> 
          <Comp.Input 
            ref={targetMandaysRef}
            id="TARGET_MANDAYS"
            type="text"
            // className={CssClass.inlineInput}
            value={editData.TARGET_MANDAYS}
            onChange={inputRequiredHandler}
            >
          </Comp.Input>
        </div>
        <div
            style={{
              display: "flex",
              margin: "1rem 5rem",
              textAlign: "left"
            }}
        >
          <label className={CssClass.inputLabel}>Required Mandays (dd:hh:mm)</label> 
          <Comp.Input 
            ref={requiredMandaysRef}
            id="TOTAL_COMPLETE_TIME"
            type="text"
            // className={CssClass.inlineInput}
            value={editData.TOTAL_COMPLETE_TIME}
            onChange={inputRequiredHandler}
            >
          </Comp.Input>
        </div> */}
        {/* Ticket Num:
        {<b>{props.viewData !== null && props.viewData.TICKET_NUM}</b>}
        <br />
        Target Mandays:
        {<b>{props.viewData !== null && props.viewData.TARGET_MANDAYS}</b>}
        <br />
        Required Mandays:
        {<b>{props.viewData !== null && props.viewData.TOTAL_COMPLETE_TIME}</b>} */}
      </>
    );

    return (
        <>
          <Comp.ConfirmModal
            show={props.showHide}
            onHide={hideModal}
            onConfirm={closeBtnOnClick}
          >
            {message}
          </Comp.ConfirmModal>
        </>
    );

}

export default CloseTicket;

